import React, { useEffect, useState } from "react";
import {
    Button,
    showToast,
    SmartTooltip,
    LogoLoader,
    Backdrop,
    TableAdv,
} from "../../../../components";
import { mapTableRows } from "../../../../utils";

import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../hooks";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import { formatWords2 } from "../../../../utils/stringUtils";
import { getMyLeadsPendingCompaniesStart, getPendingCompaniesStart } from "../../../../redux/slices/accountDetails/accountDetailsSlice";

const MyLeadsPendingApprovals = () => {
    const dispatch = useDispatch();
    const [searchText, setSearchText] = useState("");
    const [loading, setLoading] = useState(false);
    const { user } = useSelector((state) => state.auth);
    const { value } = useSelector((state) => state.totalCount);
    const { page, limit, setPage, handleLimitChange } = usePagination(
        10,
        (newPage, newLimit) => { }
    );
    const [debouncedSearch, setDebouncedSearch] = useState(searchText);
    const totalCount = value?.myleadspendingApprovals?.data || 0;
    const { myLeadsPendingCompanies } = useSelector((state) => state.accountDetails);

    console.log({totalCount, myLeadsPendingCompanies})

    const rows = (myLeadsPendingCompanies || []).map((item) => ({
        id: item.uiid,
        jobId: item?.jobIds?.[item?.jobIds?.length - 1]?.uiid,
        companyId: item.uiid,
        companyName: item.name || "",
        jobTitle: formatWords2(
            item?.jobIds?.[item?.jobIds?.length - 1]?.title || "-"
        ),
        jobLocation: item?.jobIds?.[item?.jobIds?.length - 1]?.location
            ? [
                item?.jobIds?.[item?.jobIds?.length - 1]?.location?.city,
                item?.jobIds?.[item?.jobIds?.length - 1]?.location?.state,
                item?.jobIds?.[item?.jobIds?.length - 1]?.location?.country,
            ]
                .filter(Boolean)
                .join(", ") || "-"
            : "-",
        jobDescription:
            item?.jobIds?.[item?.jobIds?.length - 1]?.description || "",
        contactDetails: (
            item?.jobIds?.[item?.jobIds?.length - 1]?.prospectIds || []
        ).map((p) => ({
            name: `${formatWords2(p.firstName)} ${formatWords2(p.lastName)}`,
            designation: formatWords2(p.designation),
            location: p.location,
            email: p.email,
            phone: `${p.mobile?.code} ${p.mobile?.number}`,
        })),
        addedBy: item?.addedBy || null,
    }));
    const normalizeUrl = (url) => {
        if (!url) return "#";
        if (!/^https?:\/\//i.test(url)) {
            return "https://" + url;
        }
        return url;
    };
    function getSiteName(url) {
        try {
            const { hostname } = new URL(url);
            let name = hostname
                .replace(/^www\./, "")
                .split(".")[0]
                .replace(/-/g, " ");
            name = name.charAt(0).toUpperCase() + name.slice(1);
            return name;
        } catch {
            return "Link";
        }
    }
    const columns = [
        {
            key: "accountName",
            label: "Account Name",
            minWidth: 150,
            render: (row) => (
                <div className="text-info cursor-pointer">
                    {formatWords2(row.companyName)}
                </div>
            ),
        },
        { key: "jobTitle", label: "Job Title", minWidth: 150 },
        { key: "jobLocation", label: "Job Location", minWidth: 150 },
        {
            key: "jobDescription",
            label: "Job Description",
            minWidth: 150,
            className: "flex-1",
            // render: (row) =>
            //   row.jobDescription ? (
            //     <a
            //       href={row.jobDescription}
            //       target="_blank"
            //       className="text-info hover:underline cursor-pointer"
            //       rel="noreferrer"
            //     >
            //       Link
            //     </a>
            //   ) : (
            //     "-"
            //   ),
            render: (row) => (
                <div className="flex-1 flex items-center gap-2">
                    {/* {row.jobDescription && typeof row.jobDescription === "string" ? */}
                    {row.jobDescription &&
                        row.jobDescription.trim() !== "" &&
                        row.jobDescription.trim() !== "-" ? (
                        <a
                            href={normalizeUrl(row.jobDescription)}
                            target="_blank"
                            className=" text-blue-600 hover:underline cursor-pointer"
                            rel="noreferrer"
                        >
                            {/* {row.jobDescription}  */}
                            {getSiteName(row.jobDescription)}
                        </a>
                    ) : (
                        "-"
                    )}
                </div>
            ),
        },
        {
            key: "addedBy",
            label: "Addeded By",
            minWidth: 150,
            render: (row) => {
                const addedBy = row?.addedBy;
                return addedBy ? (
                    <span>
                        {formatWords2(addedBy.firstName)} {formatWords2(addedBy.lastName)}
                    </span>
                ) : (
                    <span>-</span>
                );
            },
        },
        {
            key: "contactDetails",
            label: "Contact Details",
            minWidth: 150,
            render: (row) => (
                <div className="flex-1 flex items-center gap-2">
                    <div className="w-fit truncate overflow-hidden whitespace-nowrap">
                        <span className="text-success">{row.contactDetails.length}</span>/5
                    </div>
                </div>
            ),
        },
    ];


    const fetchData = async () => {
        setLoading(true);

        try {
            if (debouncedSearch.trim()) {
                let addedBy = user?.data?.uiid
                const string = addedBy ? `${debouncedSearch?.trim()}**${addedBy}` : `${debouncedSearch?.trim()}**`
                let params = {
                    coll: "Company",
                    fil: {
                        name: {
                            type: "SEARCHING", value: string,
                        },

                    },
                    lim: limit,
                    pg: page,
                    extret: "uiid firstName lastName",
                    sort: { uiid: -1 },
                    useAggregate: true
                }
                dispatch(
                    getMyLeadsPendingCompaniesStart(params))
            } else {
                let params = {
                    coll: "Company",
                    fil: {
                        "approval.isEnabled": { type: "NONE", value: true },
                        "approval.status": { type: "NONE", value: 1 },
                        addedBy: { type: "NONE", value: user?.data?.uiid },
                    },
                    ret: "uiid name jobIds addedBy",
                    ref: "JobsWithProspect",
                    lim: limit,
                    pg: page,
                    extret: "uiid firstName lastName",
                    sort: { uiid: -1 },
                }
                dispatch(
                    getMyLeadsPendingCompaniesStart(params))
            }

        } catch (error) {
            console.error("Error fetching pending companies:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(searchText);
        }, 500); // 800ms debounce

        return () => clearTimeout(timer);
    }, [searchText]);

    useEffect(() => {
        setPage(1);
    }, [searchText]);

    useEffect(() => {
        if (debouncedSearch.trim().length >= 1) {
            let addedBy = user?.data?.uiid;

            const string = addedBy
                ? `${debouncedSearch.trim()}**${addedBy}`
                : `${debouncedSearch.trim()}**`;

            dispatch(
                totalCountStart({
                    collection: "companys",
                    coll: "Company",
                    tname: "myleadspendingApprovals",
                    filters: {
                        name: {
                            type: "SEARCHING",
                            value: string,
                        },
                    },
                    app: "ats",
                    useAggregate: true,
                })
            );

            fetchData();
        } else if (debouncedSearch.trim().length == 0) {
            dispatch(
                totalCountStart({
                    collection: "companys",
                    coll: "Company",
                    tname: "myleadspendingApprovals",
                    filters: {
                        "approval.isEnabled": { type: "NONE", value: true },
                        "approval.status": { type: "NONE", value: 1 },
                        addedBy: { type: "NONE", value: user?.data?.uiid },
                    },
                    app: "ats",
                })
            );

            fetchData();
        }
    }, [debouncedSearch, limit, page]);

    const mappedRows = mapTableRows(rows, columns);
    return (
        <div className="flex-1 overflow-auto flex gap-4 p-0.5">
            <TableAdv
                tableId={"ra_leads_myleadspendingapprovals"}
                columns={columns}
                showSlNo
                serverPagination={true}
                totalCount={totalCount}
                page={page}
                limit={limit}
                onPaginationChange={setPage}
                onLimitChange={handleLimitChange}
                rows={mappedRows}
                serverSerchValue={searchText}
                serverOnSearch={(key, val) => setSearchText(val)}
                toolbarRight={{
                    search: true,
                    fullScreen: true,
                    // filter: true,
                }}
            />
            <Backdrop isOpen={loading} zIndex={51}>
                <LogoLoader />
            </Backdrop>
        </div>
    );
};

export default MyLeadsPendingApprovals;